import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/css/style.scss';
import { Provider } from 'react-redux';
import store from './store';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';

const THEME = createMuiTheme({
  typography: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: 13,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    fontWeightBold: 700,
  },
  palette: {
    primary: {
      main: '#201D1D',
      contrastText: '#fff',
    },
    secondary: {
      main: '#FABB43',
      contrastText: '#000',
    },
  },
  // props: {
  //   MuiCard: {
  //     disableRipple: true,
  //   }
  // }
});

ReactDOM.render(
  <React.StrictMode>
    <MuiThemeProvider theme={THEME}>
      <Provider store={store}>
        <App />
      </Provider>
    </MuiThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
